import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { DomainWarmupHeroSection } from "@/components/insights/domain-warmup/DomainWarmupHeroSection";
import { DomainWarmupTakeaway } from "@/components/insights/domain-warmup/DomainWarmupTakeaway";
import { DomainWarmupFounderQuote } from "@/components/insights/domain-warmup/DomainWarmupFounderQuote";
import { DomainWarmupKeyFindings } from "@/components/insights/domain-warmup/DomainWarmupKeyFindings";
import { DomainWarmupSchedule } from "@/components/insights/domain-warmup/DomainWarmupSchedule";
import { DomainWarmupCalculator } from "@/components/insights/domain-warmup/DomainWarmupCalculator";
import { DomainWarmupBestPractices } from "@/components/insights/domain-warmup/DomainWarmupBestPractices";
import { DomainWarmupChecklist } from "@/components/insights/domain-warmup/DomainWarmupChecklist";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const DomainWarmupStrategies = () => {
  return (
    <>
      <InsightEngagementTracker slug="domain-warmup-strategies" title="Domain Warmup Strategies" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Domain Health" 
          currentPage="Domain Warmup Strategies" 
        />
        <DomainWarmupHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <DomainWarmupTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <DomainWarmupFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <DomainWarmupKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DomainWarmupCalculator />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DomainWarmupSchedule />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DomainWarmupChecklist />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <DomainWarmupBestPractices />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="domain-warmup-strategies" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="domain-warmup-strategies" />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="domain-warmup-strategies" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default DomainWarmupStrategies;
